export const multipleDepositConfig = {
    name: "Payment Multiple Deposit Config",
    create:"สร้าง",
    priority:"ลำดับ",
    action:"กระทำ",
    paymentName:"Payment Name",
    cancel:"ยกเลิก",
    delete:'ลบ',
    errorHighPriority:'ลำดับความสำคัญสูงสุด',
    errorlowPriority:'ลำดับความสำคัญต่ำสุด',
    save:'บันทึก'
  };
  